// student.js - COMPLETE FIXED VERSION
import React, { useState, useEffect, useCallback, useRef } from 'react';
import Navbar from '../components/Navbar';
import StudentRewards from '../components/StudentRewards';
import studentService from '../services/studentService';
import { requestInstantHelp } from "../services/studentService";
import { useSocket } from "../context/SocketContext";


function Student() {
  const [onlineTeachers, setOnlineTeachers] = useState([]);
  const [showWelcomeBanner, setShowWelcomeBanner] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [recommendedTeachers, setRecommendedTeachers] = useState([]);
  const [helpSubject, setHelpSubject] = useState("");
  const [sessionRequests, setSessionRequests] = useState([]);
  const [scheduledSessions, setScheduledSessions] = useState([]);
  const [completedSessions, setCompletedSessions] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState('find-teachers');
  const [studentProfile, setStudentProfile] = useState(null);
  const [tokenBalance, setTokenBalance] = useState(0);
  const [favoriteTeachers, setFavoriteTeachers] = useState([]);
  const [showBonusModal, setShowBonusModal] = useState(false);
  const [isBonusAwarded, setIsBonusAwarded] = useState(false);
  const [learningStats, setLearningStats] = useState({
    totalStudyHours: 0,
    assessmentsCompleted: 0,
    sessionsAttended: 0
  });
  const { socket } = useSocket();

useEffect(() => {

  if (!socket || !socket.connected) return;

  socket.on("teachers-online", (teachers) => {

    console.log("🟢 Online teachers:", teachers);

    setOnlineTeachers(teachers);

  });

  return () => socket.off("teachers-online");

}, [socket]);

useEffect(() => {
  if (!scheduledSessions?.length) return;

  const activeSession = scheduledSessions.find(
    s => s.status === "ongoing"
  );

  if (!activeSession) return;

  const interval = setInterval(async () => {
    try {
      await studentService.sendHeartbeat(activeSession.id);
    } catch (err) {
      console.error("❌ Student heartbeat failed:", err);
    }
  }, 30000);

  return () => clearInterval(interval);

}, [scheduledSessions]);
  
  // Wallet states
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [showFundingModal, setShowFundingModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showDonationModal, setShowDonationModal] = useState(false);
  const [showTransactionHistoryModal, setShowTransactionHistoryModal] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);

  // Email search state
  const [teacherEmailSearch, setTeacherEmailSearch] = useState('');
  const [searchingByEmail, setSearchingByEmail] = useState(false);

  // Donation states
  const [studentsList, setStudentsList] = useState([]);
  const [searchStudent, setSearchStudent] = useState('');
  const [selectedStudent, setSelectedStudent] = useState(null);

  // Search and filter states
  const [searchName, setSearchName] = useState('');
  const [searchSubject, setSearchSubject] = useState('');
  const [searchState, setSearchState] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  // Funding form
  const [fundingForm, setFundingForm] = useState({
    amount: '',
    paymentMethod: 'card',
    cardNumber: '',
    expiryDate: '',
    cvv: ''
  });

  // Transfer form
  const [transferForm, setTransferForm] = useState({
    amount: '',
    recipientEmail: '',
    recipientName: '',
    purpose: 'session_payment'
  });

  // Donation form
  const [donationForm, setDonationForm] = useState({
    coinAmount: '',
    recipientEmail: '',
    recipientName: '',
    message: '',
    anonymous: false
  });

  // Get student info from localStorage
  const studentId = localStorage.getItem('userId');
  const studentName = localStorage.getItem('userName');
  const token = localStorage.getItem('token');

  useEffect(() => {
  console.log("Student ID:", studentId);
}, [studentId]);

  // ============ CREATE REFS ============
  const fetchStudentProfileRef = useRef();
  const awardStudentSignupBonusRef = useRef();

  // ============ VALIDATION ============
  useEffect(() => {
    if (!studentId) {
      console.error('❌ No student ID found in localStorage');
    }
    if (!token) {
      console.error('❌ No auth token found in localStorage');
    }
  }, [studentId, token]);

  

  // ============ BONUS HANDLING ============
    const fetchNotifications = useCallback(async () => {
    if (!studentId) return;

    try {
      const data = await studentService.getNotifications(studentId);
      setNotifications(data.notifications || []);
    } catch (error) {
      console.error('❌ Error fetching notifications:', error);
    }
  }, [studentId]);
  const awardStudentSignupBonus = useCallback(async () => {
    if (!studentId) {
      console.warn('Cannot award bonus - no student ID');
      return false;
    }

    try {
      console.log('🎯 Checking for signup bonus...');
      
      const result = await studentService.awardSignupBonus(studentId);
      
      console.log('✅ Service response:', result);
      
      if (result.success) {
        if (result.alreadyAwarded) {
          setIsBonusAwarded(true);
          setTokenBalance(result.tokenBalance);
          console.log('📌 Bonus was already awarded');
        } else {
          setIsBonusAwarded(true);
          setTokenBalance(result.tokenBalance);
          setShowBonusModal(true);
          
          console.log(`🎉 New bonus awarded! New balance: ${result.tokenBalance} EDU`);
          
          if (fetchStudentProfileRef.current) {
            fetchStudentProfileRef.current();
          }
          await fetchNotifications(); 
          alert('🎉 Welcome bonus of 10 EDU coins has been added to your wallet!');
        }
      }
      
      return result.success;
      
    } catch (error) {
      console.error('❌ Service error:', error);
      
      if (error.code === 'UNAUTHENTICATED') {
        alert('Please log in to receive your welcome bonus.');
      } else if (error.code === 'NOT_FOUND') {
        alert('User profile not found. Please complete your profile setup.');
      } else {
        alert(`Error awarding bonus: ${error.message || 'Please try again later.'}`);
      }
      
      return false;
    }
  }, [studentId, fetchNotifications]);

  // ============ STUDENT PROFILE ====================
const fetchStudentProfile = useCallback(async () => {
  if (!studentId) return;

  try {
    console.log('🔄 Fetching student profile...');

    const response = await studentService.getStudentProfile(studentId);

    // ✅ Make sure we extract profile correctly
    const profile = response.profile || response;
    console.log("PROFILE DATA:", profile);

    setStudentProfile(profile);
    setTokenBalance(profile.tokenBalance || 0);
    setWalletBalance(profile.walletBalance || 0);

    setLearningStats(profile.learningStats || {
      totalStudyHours: 0,
      assessmentsCompleted: 0,
      sessionsAttended: 0
    });

    // ================= BONUS LOGIC =================
    if (!profile.signupBonusAwarded) {
      console.log('🎁 Bonus not awarded yet. Awarding now...');
      if (awardStudentSignupBonusRef.current) {
        await awardStudentSignupBonusRef.current();
      }
    } else {
      setIsBonusAwarded(true);
      console.log('✅ Bonus already awarded in database');
    }

    // ================= BANNER CONTROL (FIXED) =================
    const shouldShowBanner =
      profile.signupBonusAwarded === true &&
      profile.welcomeBannerDismissed !== true;

    setShowWelcomeBanner(shouldShowBanner);

    // ================= TRANSACTIONS =================
    const transactionsData = await studentService.getTransactions(studentId);
    setTransactions(transactionsData.transactions || transactionsData || []);

  } catch (error) {
    console.error('❌ Error fetching student profile:', error);
  }
}, [studentId]);

  // ============ TEACHERS ====================
  const fetchTeachers = useCallback(async () => {
    if (!studentId) return;

    try {
      const teachers = await studentService.getTeachers(studentId);
      setTeachers(teachers);
    } catch (error) {
      console.error('❌ Error fetching teachers:', error);
      setTeachers([]);
    }
  }, [studentId]);

const fetchRecommendedTeachers = useCallback(async () => {
  if (!studentId) return;

  try {
    const teachers = await studentService.getRecommendedTeachers(studentId);
    console.log("🤖 AI Teachers:", teachers);
    setRecommendedTeachers(teachers || []);
  } catch (error) {
    console.error("Error fetching AI recommendations:", error);
  }
}, [studentId]);  // ← Add dependencies

  // ============ SESSION REQUESTS ====================
  const fetchSessionRequests = useCallback(async () => {
    if (!studentId) return;

    try {
      const requests = await studentService.getSessionRequests(studentId);
      setSessionRequests(requests);
    } catch (error) {
      console.error('❌ Error fetching session requests:', error);
    }
  }, [studentId]);

  const fetchSessions = async () => {
  try {
    const response = await studentService.getSessions();

    setScheduledSessions(response.scheduled || []);
    setCompletedSessions(response.completed || []);

  } catch (error) {
    console.error("Error fetching sessions:", error);
  }
};
  // ============ SESSIONS ====================
  const fetchScheduledSessions = useCallback(async () => {
    if (!studentId) return;

    try {
      const { scheduled, completed } = await studentService.getSessions(studentId);

      setScheduledSessions(scheduled || []);
      setCompletedSessions(completed || []);
    } catch (error) {
      console.error('❌ Error fetching sessions:', error);
    }
  }, [studentId]);

  // ============ NOTIFICATIONS ====================


  // ============ UPDATE REFS WHEN FUNCTIONS CHANGE ============
  useEffect(() => {
    fetchStudentProfileRef.current = fetchStudentProfile;
  }, [fetchStudentProfile]);

  useEffect(() => {
    awardStudentSignupBonusRef.current = awardStudentSignupBonus;
  }, [awardStudentSignupBonus]);

  useEffect(() => {
  if (!studentId) return;

  fetchSessionRequests();
  fetchScheduledSessions();
  fetchNotifications();  

}, [studentId, fetchSessionRequests, fetchScheduledSessions, fetchNotifications]);

useEffect(() => {

  const loadAIRecommendations = async () => {

    if (!studentId) return;

    try {

      console.log("🤖 Fetching AI recommended teachers...");

      const teachers = await studentService.getRecommendedTeachers(studentId);

      setTeachers(teachers);

    } catch (error) {

      console.error("Error fetching AI recommendations:", error);

    }

  };

  loadAIRecommendations();

}, [studentId]);

// ============ AI RECOMMENDED TEACHERS ============


  // ============ TEACHER SEARCH FUNCTIONS ============
  
  // Search teachers with filters
  
  const handleSearch = async () => {
    setIsSearching(true);
    try {
      console.log('🔍 Searching teachers with filters:', {
        name: searchName,
        subject: searchSubject,
        state: searchState
      });
      
     const response = await studentService.getTeachers({
  name: searchName,
  subject: searchSubject,
  state: searchState
});
      
      const teachersData = response.teachers || response;
      console.log(`✅ Found ${teachersData.length} teachers after search`);
      setTeachers(teachersData);
    } catch (error) {
      console.error('❌ Error searching teachers:', error);
      alert('Error searching teachers. Please try again.');
    } finally {
      setIsSearching(false);
    }
  };

  // Search teacher by email
  const searchTeacherByEmail = async () => {
    if (!teacherEmailSearch.trim()) {
      alert('Please enter a teacher email address');
      return;
    }

    setSearchingByEmail(true);
    try {
      console.log(`🔍 Searching for teacher with email: ${teacherEmailSearch}`);
      
      const response = await studentService.searchTeachersByEmail(
  teacherEmailSearch.trim()
);
      const teachersData = response.teachers || response;
      setTeachers(teachersData);
      
      console.log(`✅ Found ${teachersData.length} teachers`);
      
    } catch (error) {
      console.error('❌ Error searching teacher by email:', error);
      alert(error.message || 'Error searching teacher by email');
      setTeachers([]);
    } finally {
      setSearchingByEmail(false);
    }
  };

  // Handle Enter key for email search
  const handleEmailSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchTeacherByEmail();
    }
  };

  // Clear email search
  const clearEmailSearch = () => {
    setTeacherEmailSearch('');
    fetchTeachers();
  };

  // Clear all search filters
  const clearSearch = () => {
    setSearchName('');
    setSearchSubject('');
    setSearchState('');
    setTeacherEmailSearch('');
    fetchTeachers();
  };
  

  // Handle Enter key in teacher search
  const handleTeacherSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleInstantHelp = async () => {

  try {

    await requestInstantHelp({
  subject: helpSubject
});

    alert("Help request sent to available teachers");

  } catch (error) {

    alert(error.message);

  }

};

  
  // ============ FAVORITES FUNCTIONS ============
  const addToFavorites = async (teacherId) => {
    if (!favoriteTeachers.includes(teacherId)) {
      const updatedFavorites = [...favoriteTeachers, teacherId];
      setFavoriteTeachers(updatedFavorites);
      localStorage.setItem('favoriteTeachers', JSON.stringify(updatedFavorites));
      
      try {
        await studentService.addFavorite(studentId, teacherId);
        console.log('✅ Teacher added to favorites');
      } catch (error) {
        console.error('Error adding favorite to backend:', error);
      }
    }
  };

  const removeFromFavorites = async (teacherId) => {
    const updatedFavorites = favoriteTeachers.filter(id => id !== teacherId);
    setFavoriteTeachers(updatedFavorites);
    localStorage.setItem('favoriteTeachers', JSON.stringify(updatedFavorites));
    
    try {
      await studentService.removeFavorite(studentId, teacherId);
      console.log('✅ Teacher removed from favorites');
    } catch (error) {
      console.error('Error removing favorite from backend:', error);
    }
  };

  // ============ SESSION FUNCTIONS ============
  
  // Request session
  const requestSession = async (teacherId, subject) => {
  if (!studentName) {
    alert('Please login to request a session');
    return;
  }

  try {
    await studentService.requestSession({
      teacherId,
      subject
    });

    alert('Session request sent successfully! The teacher will respond soon.');
    fetchSessionRequests();
  } catch (error) {
    console.error('Error requesting session:', error);
    alert('Error sending session request: ' + error.message);
  }
};

  // ============ NOTIFICATION FUNCTIONS ============
  const markNotificationAsRead = async (notificationId) => {
  try {
    await studentService.markNotificationAsRead(notificationId);

    // ✅ Update local state immediately
    setNotifications(prev =>
      prev.map(n =>
        n.id === notificationId ? { ...n, read: true } : n
      )
    );

  } catch (error) {
    console.error('Error marking notification as read:', error);
  }
};

  // ============ DONATION FUNCTIONS ============
  
  // Search students for donation by email
  const searchStudents = async () => {
    if (!searchStudent.trim()) {
      setStudentsList([]);
      return;
    }
    
    try {
      const email = searchStudent.trim();
      const response = await studentService.searchStudents(studentId, email);
      const students = response.students || response;
      setStudentsList(students);
    } catch (error) {
      console.error('Error searching students:', error);
      alert(error.message);
      setStudentsList([]);
    }
  };

  // Select student for donation
  const selectStudentForDonation = (student) => {
    setSelectedStudent(student);
    setDonationForm({
      ...donationForm,
      recipientEmail: student.email,
      recipientName: student.name
    });
    setStudentsList([]);
    setSearchStudent('');
  };

  // Handle Enter key in search
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchStudents();
    }
  };

  // ============ WALLET FUNCTIONS ============
  
  // Fund wallet
  const fundWallet = async () => {
    if (!studentName) return;
    
    if (!fundingForm.amount || parseFloat(fundingForm.amount) <= 0) {
      alert('Please enter a valid amount');
      return;
    }

    if (fundingForm.paymentMethod === 'card') {
      if (!fundingForm.cardNumber || !fundingForm.expiryDate || !fundingForm.cvv) {
        alert('Please fill in all card details');
        return;
      }
    }

    const amount = parseFloat(fundingForm.amount);
    
    try {
      await studentService.fundWallet(studentId, {
        amount,
        paymentMethod: fundingForm.paymentMethod,
        cardDetails: {
          cardNumber: fundingForm.cardNumber,
          expiryDate: fundingForm.expiryDate,
          cvv: fundingForm.cvv
        }
      });
      alert(`Successfully funded ₦${amount.toLocaleString()} to your wallet!`);
      setShowFundingModal(false);
      setFundingForm({
        amount: '',
        paymentMethod: 'card',
        cardNumber: '',
        expiryDate: '',
        cvv: ''
      });
      fetchStudentProfile();
    } catch (error) {
      console.error('Error funding wallet:', error);
      alert('Error funding wallet: ' + error.message);
    }
  };

  // Transfer funds
  const transferFunds = async () => {
    if (!studentName) return;
    
    if (!transferForm.amount || parseFloat(transferForm.amount) <= 0) {
      alert('Please enter a valid amount');
      return;
    }

    if (!transferForm.recipientEmail) {
      alert('Please enter recipient email');
      return;
    }

    const amount = parseFloat(transferForm.amount);
    if (amount > walletBalance) {
      alert(`Insufficient balance. Available: ₦${walletBalance.toLocaleString()}`);
      return;
    }

    try {
      const result = await studentService.transferFunds(studentId, {
        amount,
        recipientEmail: transferForm.recipientEmail,
        recipientName: transferForm.recipientName,
        purpose: transferForm.purpose
      });
      alert(`Successfully transferred ₦${amount.toLocaleString()} to ${result.recipientName}!`);
      setShowTransferModal(false);
      setTransferForm({
        amount: '',
        recipientEmail: '',
        recipientName: '',
        purpose: 'session_payment'
      });
      fetchStudentProfile();
    } catch (error) {
      console.error('Error transferring funds:', error);
      alert('Error transferring funds: ' + error.message);
    }
  };

  // Donate EDU Coins
  const donateEDUCoins = async () => {
    if (!studentName) return;
    
    if (!donationForm.coinAmount || parseInt(donationForm.coinAmount) <= 0) {
      alert('Please enter a valid coin amount');
      return;
    }

    if (!donationForm.recipientEmail) {
      alert('Please enter recipient email');
      return;
    }

    const coinAmount = parseInt(donationForm.coinAmount);
    if (coinAmount > tokenBalance) {
      alert(`Insufficient EDU coins. Available: ${tokenBalance} EDU`);
      return;
    }

    try {
      const result = await studentService.donateEDUCoins(studentId, {
        coinAmount,
        recipientEmail: donationForm.recipientEmail,
        recipientName: donationForm.recipientName,
        message: donationForm.message,
        anonymous: donationForm.anonymous
      });
      alert(`Successfully donated ${coinAmount} EDU Coins to ${result.recipientName}!`);
      setShowDonationModal(false);
      setDonationForm({
        coinAmount: '',
        recipientEmail: '',
        recipientName: '',
        message: '',
        anonymous: false
      });
      setSelectedStudent(null);
      fetchStudentProfile();
    } catch (error) {
      console.error('Error donating EDU coins:', error);
      alert('Error donating EDU coins: ' + error.message);
    }
  };

  // Buy EDU Coins
  const buyEDUCoins = async (coinAmount, nairaAmount) => {
    if (nairaAmount > walletBalance) {
      alert(`Insufficient balance. Available: ₦${walletBalance.toLocaleString()}`);
      return;
    }

    try {
      await studentService.buyEDUCoins(studentId, {
        coinAmount,
        nairaAmount
      });
      alert(`Successfully purchased ${coinAmount} EDU Coins for ₦${nairaAmount.toLocaleString()}!`);
      fetchStudentProfile();
    } catch (error) {
      console.error('Error buying EDU coins:', error);
      alert('Error buying EDU coins: ' + error.message);
    }
  };

  // ============ SAFE FAVORITES PARSING ============
  useEffect(() => {
    const savedFavorites = localStorage.getItem('favoriteTeachers');
    if (savedFavorites) {
      try {
        setFavoriteTeachers(JSON.parse(savedFavorites));
      } catch (error) {
        console.error('Error parsing favorites from localStorage:', error);
        setFavoriteTeachers([]);
        localStorage.removeItem('favoriteTeachers');
      }
    }
  }, []);

  // ============ MAIN USE EFFECT ============
  useEffect(() => {
  if (!token || !studentId) return;

  const loadDashboardData = async () => {
    try {
      await Promise.all([
        fetchStudentProfile(),
        fetchTeachers(),
        fetchSessionRequests(),
        fetchScheduledSessions(),
        fetchNotifications(),
        fetchRecommendedTeachers()
      ]);
    } catch (error) {
      console.error("❌ Error loading dashboard data:", error);
    }
  };

  loadDashboardData();
}, [token, studentId, fetchStudentProfile, fetchTeachers, fetchSessionRequests, fetchScheduledSessions, fetchNotifications, fetchRecommendedTeachers]);
  // ============ HELPER FUNCTIONS ============
  
  // Format date safely
  const formatDate = (date) => {
    if (!date) return 'N/A';
    
    try {
      if (date.toDate && typeof date.toDate === 'function') {
        return date.toDate().toLocaleDateString();
      }
      return new Date(date).toLocaleDateString();
    } catch (e) {
      return 'Invalid date';
    }
  };

  const handleJoinSession = async (session) => {
  // ✅ Step 1 — Open the meeting link immediately
  if (session.meetingLink && !session.meetingLink.includes('${')) {
    window.open(session.meetingLink, '_blank');
  } else {
    alert('Meeting link is not available yet. Please wait for the teacher to start the session.');
    return;
  }

  // ✅ Step 2 — Mark student as joined on the backend
  // This enables EDU coin rewards when session ends
  try {
    await studentService.joinSession(session.id);
    console.log('✅ Student marked as joined');
  } catch (error) {
    // Don't block the student from joining if this fails
    console.warn('Could not mark student as joined:', error.message);
  }
};

const handleRemoveSession = async (sessionId) => {

  console.log("Deleting session:", sessionId);

  try {

    await studentService.deleteSession(sessionId);

    setScheduledSessions(prev =>
      prev.filter(session => session.id !== sessionId)
    );

  } catch (error) {

    console.error("Delete failed:", error);

  }

};

const handleConfirmSession = async (sessionId, success) => {
  try {
    console.log("✅ Confirming session:", sessionId, success);

    await studentService.confirmSession(sessionId, success);

    alert(
      success
        ? "🎉 Session confirmed! Reward processing..."
        : "❌ Session marked unsuccessful"
    );

    // 🔄 Refresh sessions
    fetchSessions(); 

  } catch (err) {
    console.error("❌ Confirm error:", err);
    alert(err.message);
  }
};

const handleRequestAgain = async (session) => {
  try {
    console.log("Requesting session again:", session);

    await studentService.requestSession({
      teacherId: session.teacherId,
      teacherName: session.teacherName,
      subject: session.subject,
      message: "Requesting session again after expiration"
    });

    alert("Session request sent again successfully.");

    // refresh requests + sessions
    fetchSessionRequests();
    fetchSessions();

  } catch (error) {
    console.error("Request again error:", error);
    alert("Failed to send request again");
  }
};
  // ============ RENDER TEACHER CARD ============
  const renderTeacherCard = (teacher) => {
    const teacherSubjects = teacher.subjects || [];
    const displaySubjects = teacherSubjects.slice(0, 3);
    
 return (
  <div key={teacher.id} className="col-md-6 col-lg-4 mb-4">
    <div className="card h-100 border-0 shadow-sm rounded-4">

      <div className="card-body d-flex flex-column">

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-start mb-3">

          <div className="d-flex gap-2">

            {/* AVATAR */}
            <div 
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "45px",
                height: "45px",
                background: "#eef2ff",
                color: "#4f46e5",
                fontWeight: "bold"
              }}
            >
              {teacher.name?.charAt(0) || "T"}
            </div>

            {/* NAME + BADGES */}
            <div>
              <h6 className="fw-bold mb-0">{teacher.name}</h6>

              {onlineTeachers.includes(teacher.id) && (
                <small className="text-success">🟢 Online</small>
              )}

              <div className="d-flex flex-wrap gap-1 mt-1">

                {teacher.badges?.includes("top_rated") && (
                  <span className="badge bg-warning text-dark">🏆</span>
                )}

                {teacher.badges?.includes("rising_star") && (
                  <span className="badge bg-danger">🔥</span>
                )}

                {teacher.badges?.includes("verified") && (
                  <span className="badge bg-success">✔</span>
                )}

                {teacher.hasTRCN && (
                  <span className="badge bg-success">TRCN</span>
                )}

              </div>
            </div>
          </div>

          {/* FAVORITE */}
          <button 
            className={`btn btn-sm ${favoriteTeachers.includes(teacher.id) ? 'btn-warning' : 'btn-outline-warning'}`}
            onClick={() => 
              favoriteTeachers.includes(teacher.id) 
                ? removeFromFavorites(teacher.id) 
                : addToFavorites(teacher.id)
            }
          >
            ⭐
          </button>
        </div>

        {/* BIO */}
        {teacher.bio && teacher.bio.trim() !== '' && (
          <p className="small text-muted mb-2">
            {teacher.bio.length > 70
              ? `${teacher.bio.substring(0, 70)}...`
              : teacher.bio}
          </p>
        )}

        {/* SUBJECTS */}
        <div className="mb-3">
          <div className="d-flex flex-wrap gap-1">
            {displaySubjects.map((subject, index) => (
              <span key={index} className="badge bg-light text-dark border">
                {subject}
              </span>
            ))}
          </div>
        </div>

        {/* INFO */}
        <div className="d-flex justify-content-between small text-muted mb-3">
          <span>📘 {teacher.experience}</span>
          <span>⭐ {teacher.rating || 'New'}</span>
        </div>

        {/* ACTIONS */}
        <div className="mt-auto d-grid gap-2">

          {teacherSubjects.slice(0, 2).map((subject, index) => (
            <button
              key={index}
              className="btn btn-primary btn-sm rounded-3"
              onClick={() => requestSession(teacher.id, subject)}
              disabled={teacher.availability && teacher.availability !== "available"}
            >
              Request {subject}
            </button>
          ))}

          {teacherSubjects.length > 2 && (
            <button className="btn btn-outline-secondary btn-sm">
              + More Subjects
            </button>
          )}

        </div>

      </div>
    </div>
  </div>
);
  };

  // ============ MAIN RENDER ============
  return (
    <div>
      <Navbar />
      
      <div 
  className="container mt-4"
  style={{ 
    maxWidth: "1200px",
    paddingLeft: "20px",
    paddingRight: "20px"
  }}
>
        {/* Dashboard Header */}
<div className="dashboard-header mb-4 p-4 rounded-4 shadow-sm bg-white">

  <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">

    {/* LEFT */}
    <div>
      <h1 className="fw-bold mb-1" style={{fontSize: "1.6rem"}}>
        Welcome back,{" "}
        <span style={{color: "#4f46e5"}}>
          {studentName ? studentName.split(" ")[0] : "Student"}
        </span>{" "}
        👋
      </h1>

      <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
        <span className="badge rounded-pill bg-light text-primary border">
          🎓 Student Dashboard
        </span>

        <span className="text-muted small">
          📅{" "}
          {new Date().toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </span>
      </div>
    </div>

    {/* DATA SAVER */}
    <button
      className="btn btn-sm"
      style={{
        border: "1px solid #facc15",
        color: "#ca8a04",
        borderRadius: "8px"
      }}
      onClick={() => {
        const current = localStorage.getItem("dataSaver") === "true";
        localStorage.setItem("dataSaver", !current);
        window.location.reload();
      }}
    >
      ⚡ Data Saver
    </button>

    {/* STATS */}
    <div className="d-flex gap-3 flex-wrap">

      <div className="p-2 px-3 rounded-3 text-center"
        style={{background: "#ecfdf5"}}>
        <small className="text-muted d-block">Sessions</small>
        <strong style={{color: "#059669"}}>
          {completedSessions.length}
        </strong>
      </div>

      <div className="p-2 px-3 rounded-3 text-center"
        style={{background: "#fef9c3"}}>
        <small className="text-muted d-block">EDU Coins</small>
        <strong style={{color: "#ca8a04"}}>
          {tokenBalance}
        </strong>
      </div>

      <div className="p-2 px-3 rounded-3 text-center"
        style={{background: "#eff6ff"}}>
        <small className="text-muted d-block">Wallet</small>
        <strong style={{color: "#2563eb"}}>
          ₦{walletBalance.toLocaleString()}
        </strong>
      </div>

    </div>

  </div>

  {/* DESCRIPTION */}
  <div className="mt-3 text-muted small">
    Find volunteer teachers, schedule sessions, and manage your learning funds
    {isBonusAwarded && (
      <span className="text-success ms-2">
        ✔ Welcome bonus received!
      </span>
    )}
  </div>

  {/* BONUS BANNER */}
  {showWelcomeBanner && (
    <div className="mt-3 p-3 rounded-3 position-relative"
      style={{background: "#ecfdf5", border: "1px solid #bbf7d0"}}>

      <button
        className="btn-close position-absolute"
        style={{top: "10px", right: "10px"}}
        onClick={async () => {
          setShowWelcomeBanner(false);
          try {
            await studentService.dismissWelcomeBanner();
          } catch (error) {
            console.error("Dismiss failed:", error);
          }
        }}
      />

      <div className="d-flex align-items-center gap-3">
        <div style={{fontSize: "1.5rem"}}>🎁</div>
        <div>
          <strong style={{color: "#065f46"}}>
            Welcome Bonus Awarded!
          </strong>
          <div className="small text-muted">
            You received <strong>10 EDU coins</strong>
          </div>
        </div>
      </div>

    </div>
  )}

  <hr className="mt-3" />
</div>
{/* ================= INSTANT HELP SECTION ================= */}
<div className="card mt-4 border-0 shadow-sm rounded-4">
  <div className="card-body p-3">

    <div className="row align-items-center g-2">

      {/* INPUT */}
      <div className="col-md-9">
        <input
          type="text"
          className="form-control form-control-lg rounded-3"
          placeholder="⚡ Need help fast? Enter subject (e.g. Math, Physics...)"
          value={helpSubject}
          onChange={(e) => setHelpSubject(e.target.value)}
        />
      </div>

      {/* BUTTON */}
      <div className="col-md-3 d-grid">
        <button
          className="btn btn-warning fw-bold rounded-3"
          onClick={handleInstantHelp}
        >
          ⚡ Get Help
        </button>
      </div>

    </div>

  </div>
</div>
{/* ======================================================== */}
        <div className="row">
         <div className="col-md-3">

  {/* SIDEBAR CARD */}
  <div className="card border-0 shadow-sm rounded-4">
    <div className="card-body text-center p-4">

      {/* PROFILE */}
      <div 
        className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
        style={{
          width: "80px",
          height: "80px",
          fontSize: "2rem",
          background: "linear-gradient(135deg, #4f46e5, #6366f1)",
          color: "white"
        }}
      >
        {studentName?.charAt(0) || 'S'}
      </div>

      <h5 className="fw-bold mb-1">{studentName || 'Student'}</h5>

      <p className="text-muted small mb-2">
        {studentProfile?.grade || 'Student'}
      </p>

      {isBonusAwarded && (
        <span className="badge bg-warning text-dark mb-3">
          🎁 Bonus Active
        </span>
      )}

      {/* EDU WALLET */}
      <div className="p-3 rounded-3 mb-3" style={{background: "#fef9c3"}}>
        <small className="text-muted d-block">EDU Coins</small>
        <h4 className="fw-bold text-warning mb-0">{tokenBalance}</h4>
      </div>

      {/* NAIRA WALLET */}
      <div className="p-3 rounded-3 mb-3" style={{background: "#ecfdf5"}}>
        <small className="text-muted d-block">Wallet</small>
        <h4 className="fw-bold text-success mb-0">
          ₦{walletBalance.toLocaleString()}
        </h4>
      </div>

      {/* ACTION BUTTONS */}
      <div className="d-grid gap-2 mb-3">

        <button 
          className="btn btn-outline-success btn-sm rounded-3"
          onClick={() => setShowWalletModal(true)}
        >
          Manage Wallet
        </button>

        <button 
          className="btn btn-outline-primary btn-sm rounded-3"
          onClick={() => setShowFundingModal(true)}
        >
          Fund Wallet
        </button>

        <button 
          className="btn btn-outline-warning btn-sm rounded-3"
          onClick={() => setShowDonationModal(true)}
        >
          Donate Coins
        </button>

      </div>

      {/* QUICK BUY */}
      <div className="p-3 rounded-3 mb-3" style={{background: "#f8fafc"}}>
        <h6 className="fw-bold mb-2">Quick Buy</h6>

        <div className="d-grid gap-2">
          <button 
            className="btn btn-outline-warning btn-sm rounded-3"
            onClick={() => buyEDUCoins(10, 100)}
          >
            Buy 10 EDU = ₦100
          </button>

          <button 
            className="btn btn-outline-warning btn-sm rounded-3"
            onClick={() => buyEDUCoins(50, 450)}
          >
            Buy 50 EDU = ₦450
          </button>
        </div>
      </div>

      {/* STATS */}
      <div className="p-3 rounded-3" style={{background: "#f1f5f9"}}>
        <h6 className="fw-bold mb-2">Progress</h6>

        <div className="row text-center">
          <div className="col-4">
            <strong className="text-primary">
              {learningStats.sessionsAttended}
            </strong>
            <br />
            <small className="text-muted">Sessions</small>
          </div>

          <div className="col-4">
            <strong className="text-success">
              {learningStats.totalStudyHours}
            </strong>
            <br />
            <small className="text-muted">Hours</small>
          </div>

          <div className="col-4">
            <strong className="text-info">
              {learningStats.assessmentsCompleted}
            </strong>
            <br />
            <small className="text-muted">Tests</small>
          </div>
        </div>
      </div>

    </div>
  </div>

  {/* NOTIFICATIONS */}
  {notifications.filter(n => !n.read).length > 0 && (
    <div className="card border-0 shadow-sm rounded-4 mt-3">
      <div className="card-body">

        <h6 className="fw-bold mb-3">
          🔔 Notifications
          <span className="badge bg-danger ms-2">
            {notifications.filter(n => !n.read).length}
          </span>
        </h6>

        <div style={{maxHeight: '200px', overflowY: 'auto'}}>

          {notifications
            .filter(notification => !notification.read)
            .map(notification => (

              <div 
                key={notification.id} 
                className="p-2 mb-2 rounded-3"
                style={{background: "#eff6ff"}}
              >

                <small>
                  <strong>{notification.title}</strong><br/>
                  {notification.message}
                </small>

                {notification.sessionId && (
                  <button 
                    className="btn btn-primary btn-sm mt-2 w-100"
                    onClick={() => {
                      setActiveTab('scheduled');
                      markNotificationAsRead(notification.id);
                    }}
                  >
                    View Session
                  </button>
                )}

                <button 
                  className="btn btn-outline-secondary btn-sm mt-1 w-100"
                  onClick={() => markNotificationAsRead(notification.id)}
                >
                  Mark as Read
                </button>

              </div>

          ))}

        </div>

      </div>
    </div>
  )}

</div>
            
          <div className="col-md-9">
            {/* Navigation Tabs */}
          <div className="mb-4">

  <div className="d-flex flex-wrap gap-2 p-2 bg-light rounded-4">

    {[
      { key: "find-teachers", label: "Find Teachers", icon: "👨‍🏫" },
      { key: "scheduled", label: "Scheduled", icon: "📅" },
      { key: "history", label: "History", icon: "📚" },
      { key: "wallet", label: "Wallet", icon: "💰" },
      { key: "favorites", label: "Favorites", icon: "⭐" }
    ].map((tab) => (

      <button
        key={tab.key}
        onClick={() => setActiveTab(tab.key)}
        className={`btn btn-sm rounded-3 px-3 py-2 fw-medium ${
          activeTab === tab.key
            ? "btn-primary shadow-sm"
            : "btn-light"
        }`}
      >
        <span className="me-1">{tab.icon}</span>
        {tab.label}
      </button>

    ))}

  </div>

</div>
            
<div className="card shadow-sm mt-4 border-0 rounded-4"
     style={{background: "#f1f5ff" }}>
      

  <div className="card-body">

    {/* HEADER */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h5 className="fw-bold mb-1 text-primary">
          🤖 AI Recommended Teachers
        </h5>
        <small className="text-muted">
          Based on your learning activity and previous sessions
        </small>
      </div>

      <span className="badge bg-primary">
        Smart Match
      </span>
    </div>

    {/* TEACHERS */}
    <div className="row">
      {recommendedTeachers.length === 0 && (
  <div className="text-center text-muted py-3">
    No AI recommendations yet
  </div>
)}

      {recommendedTeachers.slice(0, 4).map((teacher) => (

        <div className="col-md-3 mb-3" key={teacher.id || teacher.uid}>

          <div className="card h-100 border-0 shadow-sm rounded-4">

            <div className="card-body text-center">

              {/* AVATAR */}
              <div 
  className="rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center"
  style={{
    width: "50px",
    height: "50px",
    background: "#e0e7ff",
    color: "#3730a3",
    fontWeight: "bold"
  }}
>
  {(teacher.firstName || teacher.name || "T").charAt(0)}
</div>

              {/* NAME */}
              <h6 className="fw-bold mb-0">
                {teacher.firstName || teacher.name} {teacher.lastName || ""}
              </h6>

              {/* SUBJECT */}
              <small className="text-muted d-block mb-2">
                {teacher.subject || "General Tutor"}
              </small>

              {/* ONLINE */}
              {onlineTeachers.includes(teacher.id || teacher.uid) && (
                <span className="badge bg-success mb-2">
                  🟢 Online
                </span>
              )}

              {/* BUTTON */}
              <button
  className="btn btn-sm rounded-3 mt-2 w-100"
  style={{
    background: "#e0e7ff",
    color: "#3730a3",
    border: "none"
  }}
  onClick={() =>
    requestSession(
      teacher.id || teacher.uid,
      teacher.subject || "General Tutor"
    )
  }
>
  ⚡ Quick Request
</button>

            </div>

          </div>

        </div>

      ))}

    </div>

  </div>

</div>
            {/* Find Teachers Tab */}
            {activeTab === 'find-teachers' && (
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-0 fw-bold">
                      <i className="fas fa-chalkboard-teacher me-2"></i>Find Volunteer Teachers
                      <span className="badge bg-primary ms-2">{teachers.length} teachers</span>
                    </h5>
                    <div className="d-flex gap-2">
                      <button 
                        className="btn btn-sm btn-outline-secondary"
                        onClick={clearSearch}
                        disabled={isSearching || searchingByEmail}
                      >
                        <i className="fas fa-times me-1"></i>Clear All
                      </button>
                      <button 
                        className="btn btn-sm btn-outline-primary"
                        onClick={fetchTeachers}
                        disabled={isSearching || searchingByEmail}
                      >
                        <i className="fas fa-sync-alt me-1"></i>Refresh
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {/* EMAIL SEARCH SECTION */}
           <div className="p-3 rounded-4 mb-3"
     style={{background: "linear-gradient(135deg, #eff6ff, #eef2ff)"}}>

  <div className="d-flex flex-column flex-md-row align-items-center gap-3">

    {/* ICON + TEXT */}
    <div className="d-flex align-items-center gap-2">
      <div 
        className="rounded-circle d-flex align-items-center justify-content-center"
        style={{
          width: "36px",
          height: "36px",
          background: "#3b82f6",
          color: "white",
          fontSize: "1rem"
        }}
      >
        ⚡
      </div>

      <div>
        <div className="fw-bold text-primary">
          Quick Email Search
        </div>
        <small className="text-muted">
          Find a teacher instantly using email
        </small>
      </div>
    </div>

    {/* INPUT + BUTTONS */}
    <div className="flex-grow-1 d-flex gap-2">

      <input
        type="email"
        className="form-control rounded-3"
        placeholder="teacher@example.com"
        value={teacherEmailSearch}
        onChange={(e) => setTeacherEmailSearch(e.target.value)}
        onKeyPress={handleEmailSearchKeyPress}
        disabled={isSearching || searchingByEmail}
      />

      <button 
        className="btn btn-primary rounded-3 px-3 fw-bold"
        onClick={searchTeacherByEmail}
        disabled={searchingByEmail || !teacherEmailSearch.trim()}
      >
        {searchingByEmail ? (
          <span className="spinner-border spinner-border-sm"></span>
        ) : (
          "Search"
        )}
      </button>

      {teacherEmailSearch && (
        <button 
          className="btn btn-outline-secondary rounded-3"
          onClick={clearEmailSearch}
          disabled={searchingByEmail}
        >
          ✕
        </button>
      )}

    </div>

  </div>

</div>

                  {/* ORIGINAL SEARCH AND FILTER SECTION */}
      <div className="card border-0 shadow-sm rounded-4 mb-4">
  <div className="card-body p-4">

    <h6 className="fw-bold mb-3">
      🔍 Find Teachers
    </h6>

    <div className="row g-3">

      {/* NAME */}
      <div className="col-md-4">
        <label className="form-label small fw-bold text-muted">
          Name
        </label>
        <input
          type="text"
          className="form-control rounded-3"
          placeholder="e.g. John"
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
          onKeyPress={handleTeacherSearchKeyPress}
          disabled={searchingByEmail}
        />
      </div>

      {/* SUBJECT */}
      <div className="col-md-4">
        <label className="form-label small fw-bold text-muted">
          Subject
        </label>
        <select 
          className="form-select rounded-3"
          value={searchSubject} 
          onChange={(e) => setSearchSubject(e.target.value)}
          disabled={searchingByEmail}
        >
          <option value="">All Subjects</option>
          <option value="Mathematics">Mathematics</option>
          <option value="English">English Language</option>
          <option value="Physics">Physics</option>
          <option value="Chemistry">Chemistry</option>
          <option value="Biology">Biology</option>
          <option value="Computer">Computer Science</option>
          <option value="Economics">Economics</option>
          <option value="Government">Government</option>
          <option value="Literature">Literature</option>
          <option value="Accounting">Accounting</option>
          <option value="Commerce">Commerce</option>
        </select>
      </div>

      {/* STATE */}
      <div className="col-md-4">
        <label className="form-label small fw-bold text-muted">
          State
        </label>
        <input
          type="text"
          className="form-control rounded-3"
          placeholder="e.g. Abuja"
          value={searchState}
          onChange={(e) => setSearchState(e.target.value)}
          onKeyPress={handleTeacherSearchKeyPress}
          disabled={searchingByEmail}
        />
      </div>

    </div>

    {/* FILTER SUMMARY + ACTIONS */}
    <div className="d-flex flex-wrap justify-content-between align-items-center mt-4 gap-2">

      {/* ACTIVE FILTERS */}
      <div>
        {(searchName || searchSubject || searchState || teacherEmailSearch) && (
          <div className="d-flex align-items-center small text-muted">
            <i className="fas fa-filter me-2 text-primary"></i>
            {searchName && `Name: "${searchName}" `}
            {searchSubject && `Subject: "${searchSubject}" `}
            {searchState && `State: "${searchState}" `}
            {teacherEmailSearch && `Email: "${teacherEmailSearch}"`}
          </div>
        )}
      </div>

      {/* BUTTONS */}
      <div className="d-flex gap-2">

        <button 
          className="btn btn-outline-secondary rounded-3"
          onClick={() => {
            setSearchName("");
            setSearchSubject("");
            setSearchState("");
            fetchTeachers();
          }}
        >
          Reset
        </button>

        <button 
          className="btn btn-primary rounded-3 fw-bold"
          onClick={handleSearch}
          disabled={isSearching || searchingByEmail}
        >
          {isSearching ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Searching...
            </>
          ) : (
            <>
              <i className="fas fa-search me-2"></i>
              Search
            </>
          )}
        </button>

      </div>

    </div>

  </div>
</div>

                  {/* Results */}
                  {teachers.length === 0 ? (
                    <div className="text-center py-5">
                      <i className="fas fa-chalkboard-teacher fa-3x text-muted mb-3"></i>
                      <h5>No teachers found</h5>
                      <p className="text-muted">
                        {(searchName || searchSubject || searchState || teacherEmailSearch)
                          ? 'No teachers match your search. Try different search terms.'
                          : 'There are no teachers available at the moment.'}
                      </p>
                      {(searchName || searchSubject || searchState || teacherEmailSearch) && (
                        <button 
                          className="btn btn-primary mt-2"
                          onClick={clearSearch}
                        >
                          <i className="fas fa-eye me-1"></i>Show All Teachers
                        </button>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="alert alert-success mb-3">
                        <i className="fas fa-check-circle me-2"></i>
                        Found <strong>{teachers.length}</strong> teacher{teachers.length !== 1 ? 's' : ''}
                        {searchSubject && ` for "${searchSubject}"`}
                        {searchName && ` with name containing "${searchName}"`}
                        {searchState && ` in "${searchState}" state`}
                        {teacherEmailSearch && ` with email containing "${teacherEmailSearch}"`}
                      </div>

                      <div className="row">
                        {teachers.map(teacher => renderTeacherCard(teacher))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Scheduled Sessions Tab */}
            {activeTab === 'scheduled' && (
              <div className="card">
                <div className="card-header bg-light">
                  <h5 className="card-title mb-0 fw-bold">
                    <i className="fas fa-calendar-check me-2"></i>My Scheduled Sessions
                    {sessionRequests.filter(r => r.status === 'accepted' && !r.meetingLink).length > 0 && (
                      <span className="badge bg-success ms-2">
                        {sessionRequests.filter(r => r.status === 'accepted').length} waiting for schedule
                      </span>
                    )}
                  </h5>
                </div>
                <div className="card-body">
                  {scheduledSessions.length === 0 && sessionRequests.filter(r => r.status === 'accepted').length === 0 ? (
                    <div className="text-center py-4">
                      <i className="fas fa-calendar-times fa-3x text-muted mb-3"></i>
                      <h5>No scheduled sessions yet</h5>
                      <p className="text-muted">Find teachers and request sessions to get started</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Teacher</th>
                            <th>Subject</th>
                            <th>Date & Time</th>
                            <th>Duration</th>
                            <th>Status</th>
                            <th>Meeting Link</th>
                          </tr>
                        </thead>
                        <tbody>

{/* 1️⃣ Pending session requests waiting for teacher */}
{sessionRequests
  .filter(r => r.status === 'pending')
  .map(request => (
    <tr key={request.id} className="table-warning">
      <td>
        <div className="d-flex align-items-center">
          <div
            className="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center me-2"
            style={{ width: '30px', height: '30px', fontSize: '0.9rem' }}
          >
            {request.teacherName?.charAt(0) || 'T'}
          </div>
          {request.teacherName}
        </div>
      </td>

      <td>
        <span className="badge bg-info">{request.subject}</span>
      </td>

      <td className="text-muted">
        Waiting for teacher response
      </td>

      <td>{request.duration || 60} mins</td>

      <td>
        <span className="badge bg-warning">
          ⏳ Pending
        </span>
      </td>

      <td>
        <span className="text-muted">Awaiting approval</span>
      </td>
    </tr>
))}
                          
                          {/* Show accepted requests from sessionRequests */}
                          {sessionRequests.filter(r => r.status === 'accepted' && !r.meetingLink).map(request => (
                            <tr key={request.id} className="table-success">
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-2" 
                                       style={{width: '30px', height: '30px', fontSize: '0.9rem'}}>
                                    {request.teacherName?.charAt(0) || 'T'}
                                  </div>
                                  {request.teacherName}
                                </div>
                              </td>
                              <td>
                                <span className="badge bg-info">{request.subject}</span>
                              </td>
                              <td>
                                <strong>{request.scheduledDate || request.scheduleDate || 'Date pending'}</strong>
                                {request.scheduledTime && ` at ${request.scheduledTime}`}
                              </td>
                              <td>{request.duration || 60} mins</td>
                              <td>
                                <span className="badge bg-success">
                                  <i className="fas fa-check-circle me-1"></i>Accepted
                                </span>
                              </td>
                              <td>
                                {request.meetingLink ? (
                                  <button 
                                    className="btn btn-success btn-sm"
                                    onClick={() => window.open(request.meetingLink, '_blank')}
                                  >
                                    <i className="fas fa-video me-1"></i>Join Meeting
                                  </button>
                                ) : (
                                  <span className="text-warning">
                                  <i className="fas fa-clock me-1"></i>
                                    Waiting for teacher to schedule
                          </span>
                                )}
                              </td>
                            </tr>
                          ))}
                          
                          {/* Show scheduled sessions from sessions collection */}
                          {scheduledSessions.map(session => (
                            <tr key={session.id}>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2" 
                                       style={{width: '30px', height: '30px', fontSize: '0.9rem'}}>
                                    {session.teacherName?.charAt(0) || 'T'}
                                  </div>
                                  {session.teacherName}
                                </div>
                              </td>
                              <td>
                                <span className="badge bg-info">{session.subject}</span>
                              </td>
                              <td>
                                <strong>{session.scheduleDate}</strong> at {session.scheduleTime}
                                {session.duration && ` (${session.duration} mins)`}
                              </td>
                              <td>{session.duration} mins</td>
                              <td>
                                <span className={`badge ${
  session.status === 'scheduled' ? 'bg-warning' :
  session.status === 'ongoing' ? 'bg-primary' :
  session.status === 'completed' ? 'bg-success' :
  session.status === 'expired' ? 'bg-danger' :
  'bg-secondary'
}`}>
  {session.status === 'scheduled' && '⏳ Scheduled'}
  {session.status === 'ongoing' && '🔵 Ongoing'}
  {session.status === 'completed' && '✅ Completed'}
  {session.status === 'expired' && '❌ Expired'}
</span>
                              </td>
                              <td>
                                {session.status === 'expired' ? (

  <div className="d-flex gap-1">
    
    <button
  className="btn btn-outline-danger btn-sm"
  onClick={() => {
    console.log("Remove clicked", session.id);
    handleRemoveSession(session.id);
  }}
>
  <i className="fas fa-trash me-1"></i>Remove
</button>

    <button
  className="btn btn-primary btn-sm"
  onClick={() => handleRequestAgain(session)}
>
  <i className="fas fa-redo me-1"></i>Request New Session
</button>

  </div>

) : session.meetingLink ? (

  <button 
    className="btn btn-success btn-sm"
    onClick={() => handleJoinSession(session)}
  >
    <i className="fas fa-video me-1"></i>Join Session
  </button>

) : (

  <span className="text-muted">No link</span>

)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Session History Tab */}
            {activeTab === 'history' && (
              <div className="card">
                <div className="card-header bg-light">
                  <h5 className="card-title mb-0 fw-bold">
                    <i className="fas fa-history me-2"></i>Session History
                  </h5>
                </div>
                <div className="card-body">
                  {completedSessions.length === 0 ? (
                    <div className="text-center py-4">
                      <i className="fas fa-history fa-3x text-muted mb-3"></i>
                      <h5>No completed sessions yet</h5>
                      <p className="text-muted">Complete your first session to see history here</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Teacher</th>
                            <th>Subject</th>
                            <th>Date Completed</th>
                            <th>Duration</th>
                            <th>Session Video</th>
                            <th>Rating</th>
                          </tr>
                        </thead>
                        <tbody>
  {completedSessions.map(session => (
    <tr key={session.id}>
      
      {/* TEACHER */}
      <td>
        <div className="d-flex align-items-center">
          <div
            className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-2"
            style={{ width: '30px', height: '30px', fontSize: '0.9rem' }}
          >
            {session.teacherName?.charAt(0) || 'T'}
          </div>
          {session.teacherName}
        </div>
      </td>

      {/* SUBJECT */}
      <td>
        <span className="badge bg-primary">{session.subject}</span>
      </td>

      {/* DATE */}
      <td>{formatDate(session.endTime)}</td>

      {/* DURATION */}
      <td>{session.duration} mins</td>

      {/* VIDEO */}
      <td>
        {session.sessionVideo ? (
          <a
            href={session.sessionVideo}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-info btn-sm"
          >
            <i className="fas fa-play-circle me-1"></i>Watch Recording
          </a>
        ) : (
          <span className="text-muted">No video</span>
        )}
      </td>

      {/* RATING */}
      <td>
        <div className="rating">
          {[1, 2, 3, 4, 5].map(star => (
            <span key={star} className="text-warning">★</span>
          ))}
        </div>
      </td>

      {/* ✅ NEW: CONFIRMATION COLUMN */}
      <td>
        {!session.studentConfirmed ? (
          <div>
            <small className="text-muted d-block mb-1">
              Was this session successful?
            </small>

            <div className="d-flex gap-2">
              <button
                className="btn btn-success btn-sm"
                onClick={() => handleConfirmSession(session.id, true)}
              >
                ✅ Yes
              </button>

              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleConfirmSession(session.id, false)}
              >
                ❌ No
              </button>
            </div>
          </div>
        ) : (
          <span className="badge bg-success">
            ✔ Confirmed
          </span>
        )}
      </td>

    </tr>
  ))}
</tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Rewards Tab */}
            {activeTab === 'rewards' && (
              <div className="card">
                <div className="card-header bg-light">
                  <h5 className="card-title mb-0 fw-bold">
                    <i className="fas fa-trophy me-2"></i>Learning Rewards & Incentives
                  </h5>
                </div>
                <div className="card-body">
                  {isBonusAwarded && (
                    <div className="alert alert-warning mb-4">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-gift fa-2x me-3"></i>
                        <div>
                          <h5 className="mb-1">Your Welcome Bonus is Active! 🎉</h5>
                          <p className="mb-0">
                            You have <strong>10 EDU coins</strong> from your welcome bonus. 
                            Use them to register for exams or purchase study materials below.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  <StudentRewards />
                </div>
              </div>
            )}

            {/* Wallet Tab */}
            {activeTab === 'wallet' && (
              <div className="card">
                <div className="card-header bg-light">
                  <h5 className="card-title mb-0 fw-bold">
                    <i className="fas fa-wallet me-2"></i>My Wallet Dashboard
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row mb-4">
                    <div className="col-md-6">
                      <div className="card bg-warning text-white">
                        <div className="card-body text-center">
                          <h5>EDU Coin Balance</h5>
                          <h2>{tokenBalance} EDU</h2>
                          <p className="mb-0">For platform utilities & donations</p>
                          {isBonusAwarded && (
                            <small className="mt-1">
                              <i className="fas fa-gift me-1"></i>Includes 10 EDU welcome bonus
                            </small>
                          )}
                          <div className="mt-3">
                            <button className="btn btn-light btn-sm" onClick={() => setShowDonationModal(true)}>
                              <i className="fas fa-gift me-1"></i>Donate Coins
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card bg-success text-white">
                        <div className="card-body text-center">
                          <h5>Naira Wallet Balance</h5>
                          <h2>₦{walletBalance.toLocaleString()}</h2>
                          <p className="mb-0">Withdrawable & transferable</p>
                          <div className="mt-3">
                            <button className="btn btn-light btn-sm me-2" onClick={() => setShowFundingModal(true)}>
                              <i className="fas fa-plus me-1"></i>Add Funds
                            </button>
                            <button className="btn btn-light btn-sm" onClick={() => setShowTransferModal(true)}>
                              <i className="fas fa-paper-plane me-1"></i>Send Money
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Welcome Bonus Banner */}
                  {isBonusAwarded && (
                    <div className="alert alert-success mb-4">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-gift fa-2x me-3"></i>
                        <div>
                          <h5 className="mb-1">Welcome Bonus Details</h5>
                          <p className="mb-0">
                            <strong>10 EDU coins</strong> were added to your wallet as a welcome bonus. 
                            <br/>
                            <small className="text-muted">
                              Bonus awarded on: {studentProfile?.signupBonusDate ? formatDate(studentProfile.signupBonusDate) : 'Upon registration'}
                            </small>
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Quick Actions */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <h6 className="fw-bold mb-3">
                        <i className="fas fa-bolt me-2"></i>Quick Actions
                      </h6>
                      <div className="d-flex flex-wrap gap-2">
                        <button className="btn btn-primary" onClick={() => setShowFundingModal(true)}>
                          <i className="fas fa-money-bill-wave me-1"></i>Fund Wallet
                        </button>
                        <button className="btn btn-success" onClick={() => setShowTransferModal(true)}>
                          <i className="fas fa-paper-plane me-1"></i>Transfer Funds
                        </button>
                        <button className="btn btn-warning" onClick={() => setShowDonationModal(true)}>
                          <i className="fas fa-hand-holding-heart me-1"></i>Donate EDU Coins
                        </button>
                        <button className="btn btn-info" onClick={() => setShowTransactionHistoryModal(true)}>
                          <i className="fas fa-history me-1"></i>Transaction History
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Recent Transactions */}
                  <div className="row">
                    <div className="col-12">
                      <h6 className="fw-bold mb-3">
                        <i className="fas fa-exchange-alt me-2"></i>Recent Transactions
                      </h6>
                      {transactions && transactions.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table table-sm">
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Reference</th>
                              </tr>
                            </thead>
                            <tbody>
                              {transactions.slice(-5).reverse().map((tx) => (
                                <tr key={tx.id}>
                                  <td>{formatDate(tx.date)}</td>
                                  <td>
                                    <span className={`badge ${
                                      tx.type === 'funding' ? 'bg-success' :
                                      tx.type === 'transfer_out' ? 'bg-primary' :
                                      tx.type === 'transfer_in' ? 'bg-info' :
                                      tx.type === 'coin_purchase' ? 'bg-warning' :
                                      tx.type === 'coin_donation_out' || tx.type === 'coin_donation_in' ? 'bg-secondary' :
                                      tx.type === 'signup_bonus' ? 'bg-danger' : 'bg-secondary'
                                    }`}>
                                      {tx.type.replace(/_/g, ' ')}
                                    </span>
                                  </td>
                                  <td>
                                    {tx.type === 'transfer_out' || tx.type === 'transfer_in' ? (
                                      <>
                                        {tx.type === 'transfer_out' ? 'To: ' : 'From: '}
                                        {tx.recipientName || tx.senderName || tx.recipientEmail || tx.senderEmail}
                                      </>
                                    ) : tx.type === 'coin_purchase' ? (
                                      `EDU Coin Purchase (${tx.rate})`
                                    ) : tx.type === 'coin_donation_out' || tx.type === 'coin_donation_in' ? (
                                      <>
                                        {tx.type === 'coin_donation_out' ? 'Donation to: ' : 'Donation from: '}
                                        {tx.recipientName || tx.donorName || tx.recipientEmail}
                                        {tx.message && <br/>}
                                        {tx.message && <small className="text-muted">"{tx.message}"</small>}
                                      </>
                                    ) : tx.type === 'signup_bonus' ? (
                                      <span className="text-success">
                                        <i className="fas fa-gift me-1"></i>Welcome Signup Bonus
                                      </span>
                                    ) : (
                                      'Wallet Funding'
                                    )}
                                  </td>
                                  <td>
                                    {tx.type === 'coin_purchase' || tx.type === 'coin_donation_out' || tx.type === 'coin_donation_in' || tx.type === 'signup_bonus' ? (
                                      <span className="text-warning fw-bold">
                                        {tx.coinAmount} EDU
                                        {tx.nairaAmount && (
                                          <>
                                            <br/>
                                            <small className="text-muted">₦{tx.nairaAmount?.toLocaleString()}</small>
                                          </>
                                        )}
                                      </span>
                                    ) : (
                                      <span className={tx.type === 'funding' || tx.type === 'transfer_in' ? 'text-success' : 'text-primary'}>
                                        ₦{tx.amount?.toLocaleString()}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    <span className={`badge ${
                                      tx.status === 'completed' ? 'bg-success' :
                                      tx.status === 'pending' ? 'bg-warning' : 'bg-danger'
                                    }`}>
                                      {tx.status}
                                    </span>
                                  </td>
                                  <td><small>{tx.reference}</small></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div className="alert alert-info">
                          <i className="fas fa-info-circle me-2"></i>
                          No transactions yet. Fund your wallet to get started!
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Favorites Tab */}
            {activeTab === 'favorites' && (
              <div className="card">
                <div className="card-header bg-light">
                  <h5 className="card-title mb-0 fw-bold">
                    <i className="fas fa-heart me-2"></i>Favorite Teachers
                  </h5>
                </div>
                <div className="card-body">
                  {favoriteTeachers.length === 0 ? (
                    <div className="text-center py-4">
                      <i className="fas fa-heart fa-3x text-muted mb-3"></i>
                      <h5>No favorite teachers yet</h5>
                      <p className="text-muted">Click the star icon on teachers to add them to favorites</p>
                    </div>
                  ) : (
                    <div className="row">
                      {teachers
                        .filter(teacher => favoriteTeachers.includes(teacher.id))
                        .map(teacher => renderTeacherCard(teacher))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ============ MODALS ============ */}
      {/* Welcome Bonus Modal */}
      {showBonusModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-warning text-white">
                <h5 className="modal-title">🎉 Welcome Bonus Awarded! 🎉</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowBonusModal(false)}></button>
              </div>
              <div className="modal-body text-center">
                <div className="mb-4">
                  <i className="fas fa-gift fa-4x text-warning mb-3"></i>
                  <h4 className="text-success">Congratulations!</h4>
                  <p className="lead">
                    You have received <strong className="text-warning">10 EDU coins</strong> as a welcome bonus!
                  </p>
                  <div className="alert alert-info">
                    <h6>How to use your bonus:</h6>
                    <ul className="text-start">
                      <li>Register for exams (WAEC, NECO, JAMB)</li>
                      <li>Purchase past questions and study materials</li>
                      <li>Donate to help other students</li>
                      <li>Access premium learning resources</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                <button 
                  type="button" 
                  className="btn btn-warning btn-lg"
                  onClick={() => {
                    setShowBonusModal(false);
                    setActiveTab('rewards');
                  }}
                >
                  <i className="fas fa-trophy me-2"></i>View Rewards
                </button>
                <button 
                  type="button" 
                  className="btn btn-outline-primary"
                  onClick={() => setShowBonusModal(false)}
                >
                  Continue to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Wallet Modal */}
      {showWalletModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Manage Your Wallet</h5>
                <button type="button" className="btn-close" onClick={() => setShowWalletModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="card bg-warning text-white">
                      <div className="card-body text-center">
                        <h5>EDU Coin Balance</h5>
                        <h2>{tokenBalance} EDU</h2>
                        <p>For platform utilities & donations</p>
                        {isBonusAwarded && (
                          <div className="alert alert-light mt-2">
                            <small>
                              <strong>Includes:</strong><br/>
                              • Welcome Bonus: <strong>10 EDU</strong><br/>
                              {tokenBalance > 10 && `• Additional: ${tokenBalance - 10} EDU`}
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="card bg-success text-white">
                      <div className="card-body text-center">
                        <h5>Naira Wallet Balance</h5>
                        <h2>₦{walletBalance.toLocaleString()}</h2>
                        <p>Available for use</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <h6 className="fw-bold mb-3">Quick Actions</h6>
                    <div className="d-grid gap-2">
                      <button className="btn btn-primary" onClick={() => {
                        setShowWalletModal(false);
                        setShowFundingModal(true);
                      }}>
                        <i className="fas fa-money-bill-wave me-1"></i>Add Funds to Wallet
                      </button>
                      <button className="btn btn-success" onClick={() => {
                        setShowWalletModal(false);
                        setShowTransferModal(true);
                      }}>
                        <i className="fas fa-paper-plane me-1"></i>Send Money to Others
                      </button>
                      <button className="btn btn-info" onClick={() => {
                        setShowWalletModal(false);
                        setShowDonationModal(true);
                      }}>
                        <i className="fas fa-hand-holding-heart me-1"></i>Donate EDU Coins
                      </button>
                      <button className="btn btn-warning" onClick={() => {
                        setShowWalletModal(false);
                        setShowTransactionHistoryModal(true);
                      }}>
                        <i className="fas fa-history me-1"></i>View Transaction History
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowWalletModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Funding Modal */}
      {showFundingModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Fund Your Wallet</h5>
                <button type="button" className="btn-close" onClick={() => setShowFundingModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-info">
                  Current Balance: <strong>₦{walletBalance.toLocaleString()}</strong>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Amount (₦)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={fundingForm.amount}
                    onChange={(e) => setFundingForm({...fundingForm, amount: e.target.value})}
                    placeholder="Enter amount to add"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Payment Method</label>
                  <select 
                    className="form-select"
                    value={fundingForm.paymentMethod}
                    onChange={(e) => setFundingForm({...fundingForm, paymentMethod: e.target.value})}
                  >
                    <option value="card">Debit/Credit Card</option>
                    <option value="bank_transfer">Bank Transfer</option>
                    <option value="wallet">Digital Wallet</option>
                  </select>
                </div>
                
                {fundingForm.paymentMethod === 'card' && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">Card Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={fundingForm.cardNumber}
                        onChange={(e) => setFundingForm({...fundingForm, cardNumber: e.target.value})}
                        placeholder="1234 5678 9012 3456"
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Expiry Date</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fundingForm.expiryDate}
                          onChange={(e) => setFundingForm({...fundingForm, expiryDate: e.target.value})}
                          placeholder="MM/YY"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">CVV</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fundingForm.cvv}
                          onChange={(e) => setFundingForm({...fundingForm, cvv: e.target.value})}
                          placeholder="123"
                        />
                      </div>
                    </div>
                  </>
                )}
                
                {fundingForm.paymentMethod === 'bank_transfer' && (
                  <div className="alert alert-success">
                    <strong>Bank Transfer Details:</strong><br/>
                    Bank: Access Bank<br/>
                    Account: 1706440914<br/>
                    Dom Account:1709486661
                    Name: Girls for Tech Innovators Competition Initiative<br/>
                    <small>Use your email as reference</small>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowFundingModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={fundWallet}>Add Funds</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Transfer Modal */}
      {showTransferModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Transfer Naira Funds</h5>
                <button type="button" className="btn-close" onClick={() => setShowTransferModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning">
                  Available Balance: <strong>₦{walletBalance.toLocaleString()}</strong>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Recipient Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={transferForm.recipientEmail}
                    onChange={(e) => setTransferForm({...transferForm, recipientEmail: e.target.value})}
                    placeholder="Enter recipient's registered email"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Recipient Name (Optional)</label>
                  <input
                    type="text"
                    className="form-control"
                    value={transferForm.recipientName}
                    onChange={(e) => setTransferForm({...transferForm, recipientName: e.target.value})}
                    placeholder="Enter recipient's name"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Amount (₦)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={transferForm.amount}
                    onChange={(e) => setTransferForm({...transferForm, amount: e.target.value})}
                    placeholder="Enter amount to transfer"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Purpose</label>
                  <select 
                    className="form-select"
                    value={transferForm.purpose}
                    onChange={(e) => setTransferForm({...transferForm, purpose: e.target.value})}
                  >
                    <option value="session_payment">Session Payment</option>
                    <option value="gift">Gift</option>
                    <option value="refund">Refund</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowTransferModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={transferFunds}>Transfer Now</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Donation Modal */}
      {showDonationModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Donate EDU Coins</h5>
                <button type="button" className="btn-close" onClick={() => {
                  setShowDonationModal(false);
                  setSelectedStudent(null);
                  setStudentsList([]);
                  setSearchStudent('');
                }}></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning">
                  Your EDU Coin Balance: <strong>{tokenBalance} EDU</strong>
                  <br/>
                  <small>Help another student by donating your EDU coins. They can use them for exam registration, past questions, and other educational resources.</small>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Enter Student's Email</label>
                  <div className="input-group">
                    <input
                      type="email"
                      className="form-control"
                      value={searchStudent}
                      onChange={(e) => setSearchStudent(e.target.value)}
                      onKeyPress={handleSearchKeyPress}
                      placeholder="Enter student's email address"
                    />
                    <button className="btn btn-outline-secondary" onClick={searchStudents}>
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                  <small className="text-muted">Press Enter or click search</small>
                </div>
                
                {studentsList.length > 0 && (
                  <div className="mb-3">
                    <label className="form-label">Select Student:</label>
                    <div className="list-group" style={{maxHeight: '150px', overflowY: 'auto'}}>
                      {studentsList.map(student => (
                        <button
                          key={student.id}
                          className={`list-group-item list-group-item-action ${selectedStudent?.id === student.id ? 'active' : ''}`}
                          onClick={() => selectStudentForDonation(student)}
                        >
                          <div className="d-flex align-items-center">
                            <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2" 
                                 style={{width: '30px', height: '30px', fontSize: '0.9rem'}}>
                              {student.name?.charAt(0) || 'S'}
                            </div>
                            <div className="text-start">
                              <strong>{student.name}</strong>
                              <br/>
                              <small>{student.email} • {student.role || 'Student'}</small>
                            </div>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                
                {selectedStudent && (
                  <div className="alert alert-info mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <strong>Selected Student:</strong> {selectedStudent.name} ({selectedStudent.email})
                      </div>
                      <button 
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => {
                          setSelectedStudent(null);
                          setDonationForm({
                            ...donationForm,
                            recipientEmail: '',
                            recipientName: ''
                          });
                          setSearchStudent('');
                        }}
                      >
                        Change
                      </button>
                    </div>
                  </div>
                )}
                
                <div className="mb-3">
                  <label className="form-label">Amount of EDU Coins to Donate</label>
                  <input
                    type="number"
                    className="form-control"
                    value={donationForm.coinAmount}
                    onChange={(e) => setDonationForm({...donationForm, coinAmount: e.target.value})}
                    placeholder="Enter number of EDU coins"
                    min="1"
                    max={tokenBalance}
                  />
                  <small className="text-muted">Available: {tokenBalance} EDU</small>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Message (Optional)</label>
                  <textarea
                    className="form-control"
                    value={donationForm.message}
                    onChange={(e) => setDonationForm({...donationForm, message: e.target.value})}
                    placeholder="Add a motivational message to the student"
                    rows="2"
                  />
                </div>
                
                <div className="form-check mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="anonymousCheck"
                    checked={donationForm.anonymous}
                    onChange={(e) => setDonationForm({...donationForm, anonymous: e.target.checked})}
                  />
                  <label className="form-check-label" htmlFor="anonymousCheck">
                    Donate anonymously (your name won't be shown to the recipient)
                  </label>
                </div>
                
                <div className="alert alert-success">
                  <strong>Why donate?</strong>
                  <ul className="mb-0">
                    <li>Help peers register for exams (WAEC, NECO, JAMB)</li>
                    <li>Enable access to study materials</li>
                    <li>Support learning partners in need</li>
                    <li>Build a supportive learning community</li>
                  </ul>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => {
                  setShowDonationModal(false);
                  setSelectedStudent(null);
                  setStudentsList([]);
                  setSearchStudent('');
                }}>Cancel</button>
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={donateEDUCoins}
                  disabled={!selectedStudent || !donationForm.coinAmount || parseInt(donationForm.coinAmount) <= 0}
                >
                  Donate Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Transaction History Modal */}
      {showTransactionHistoryModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Transaction History</h5>
                <button type="button" className="btn-close" onClick={() => setShowTransactionHistoryModal(false)}></button>
              </div>
              <div className="modal-body">
                {transactions && transactions.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-sm">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Type</th>
                          <th>Description</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Reference</th>
                        </tr>
                      </thead>
                      <tbody>
                        {transactions.slice().reverse().map((tx) => (
                          <tr key={tx.id}>
                            <td>{formatDate(tx.date)}</td>
                            <td>
                              <span className={`badge ${
                                tx.type === 'funding' ? 'bg-success' :
                                tx.type === 'transfer_out' ? 'bg-primary' :
                                tx.type === 'transfer_in' ? 'bg-info' :
                                tx.type === 'coin_purchase' ? 'bg-warning' :
                                tx.type === 'coin_donation_out' || tx.type === 'coin_donation_in' ? 'bg-secondary' :
                                tx.type === 'signup_bonus' ? 'bg-danger' : 'bg-secondary'
                              }`}>
                                {tx.type.replace(/_/g, ' ')}
                              </span>
                            </td>
                            <td>
                              {tx.type === 'transfer_out' || tx.type === 'transfer_in' ? (
                                <>
                                  {tx.type === 'transfer_out' ? 'To: ' : 'From: '}
                                  {tx.recipientName || tx.senderName || tx.recipientEmail || tx.senderEmail}
                                </>
                              ) : tx.type === 'coin_purchase' ? (
                                `EDU Coin Purchase (${tx.rate})`
                              ) : tx.type === 'coin_donation_out' || tx.type === 'coin_donation_in' ? (
                                <>
                                  {tx.type === 'coin_donation_out' ? 'Donation to: ' : 'Donation from: '}
                                  {tx.recipientName || tx.donorName || tx.recipientEmail}
                                  {tx.message && <br/>}
                                  {tx.message && <small className="text-muted">"{tx.message}"</small>}
                                </>
                              ) : tx.type === 'signup_bonus' ? (
                                <span className="text-success">
                                  <i className="fas fa-gift me-1"></i>Welcome Signup Bonus
                                </span>
                              ) : (
                                'Wallet Funding'
                              )}
                            </td>
                            <td>
                              {tx.type === 'coin_purchase' || tx.type === 'coin_donation_out' || tx.type === 'coin_donation_in' || tx.type === 'signup_bonus' ? (
                                <span className="text-warning fw-bold">
                                  {tx.coinAmount} EDU
                                  {tx.nairaAmount && (
                                    <>
                                      <br/>
                                      <small className="text-muted">₦{tx.nairaAmount?.toLocaleString()}</small>
                                    </>
                                  )}
                                </span>
                              ) : (
                                <span className={tx.type === 'funding' || tx.type === 'transfer_in' ? 'text-success' : 'text-primary'}>
                                    ₦{tx.amount?.toLocaleString()}
                                </span>
                              )}
                            </td>
                            <td>
                              <span className={`badge ${
                                tx.status === 'completed' ? 'bg-success' :
                                tx.status === 'pending' ? 'bg-warning' : 'bg-danger'
                              }`}>
                                {tx.status}
                              </span>
                            </td>
                            <td><small>{tx.reference}</small></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <i className="fas fa-exchange-alt fa-3x text-muted mb-3"></i>
                    <h5>No transactions yet</h5>
                    <p className="text-muted">Your transaction history will appear here</p>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowTransactionHistoryModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Student;